import commonConfig from 'config/commonConfig';
import store from 'app/store';
import history from 'app/history';
import ObjectHelper from 'utils/ObjectHelper';
import {updateResponse} from 'redux/sessionAction';
import {endAPI} from 'redux/appAction';

//**check out status code */
const checkResponseStatusCode = (responseList) => {
  let statusCodeObj = {code: '', errorList: []};
  if (!ObjectHelper.isNullOrlengthZore(responseList)) {
    for (let element of responseList) {
      if (!ObjectHelper.isNull(element)) {
        if (element.status === 403) {
          statusCodeObj.code = element.status;
          return statusCodeObj;
        }
        if (element.status === 500) {
          if (
            !ObjectHelper.isNull(element.response) &&
            !ObjectHelper.isNull(element.response.errorInfo)
          ) {
            statusCodeObj.errorList.push(element.response.errorInfo);
          } else {
            statusCodeObj.errorList.push({code: element.status});
          }
        } else if (element.status !== 200 && element.status !== 201) {
          statusCodeObj.errorList.push({code: element.status});
        }
      }
    }
    if (ObjectHelper.isNullOrlengthZore(statusCodeObj.errorList)) {
      statusCodeObj.code = 200;
    }
    return statusCodeObj;
  }
};

const getDocQuestion = (questionList) => {
  let questions = [];
  if (!ObjectHelper.isNullOrlengthZore(questionList)) {
    questions = questionList.filter((e) => e.questionNumber === '90' || e.questionNumber === '91');
  }
  return questions;
};

const buildGetKnowRequest = (action) => {
  return action;
};

const convertGetExpResponse = (questionResponse, resultResponse) => {
  let convertResp = {docResults: null, questionList: []};
  let questionList = questionResponse.response;
  let result = resultResponse.response;
  if (
    questionList.questions &&
    questionList.questions.length &&
    result &&
    result.resultResponse &&
    result.resultResponse[0].questionnaireResponse &&
    result.resultResponse[0].questionnaireResponse[0] &&
    result.resultResponse[0].questionnaireResponse[0].questionResponse
  ) {
    let resultData = result.resultResponse[0].questionnaireResponse[0].questionResponse;
    questionList.questions.map((item) => {
      resultData.map((info, index) => {
        if (info.questionNumber === item.questionNumber) {
          item.answers.map((an) => {
            if (an.answerDisplayOrderNumber === resultData[index].answerNumber) {
              an.isInput = true;
            }
          });
        }
      });
    });
    convertResp.docResults = getDocQuestion(resultData);
    convertResp.questionList = questionList;
    console.log('result=== exp', convertResp);
  }
  return convertResp;
};

//get doc id
const converGetDocId = (resultResponse) => {
  let docId = '';
  let result = resultResponse.response;
  let answersList = result.resultResponse[0].questionnaireResponse[0].questionResponse;
  if (answersList && answersList.length) {
    const docResults = answersList.filter(
      (e) => e.questionNumber === '90' && e.answerNumber === 'A',
    );
    if (docResults.length) {
      docId = docResults[0].answerInputText;
    }
  }
  return docId;
};

const dataUrlTofile = (response) => {
  if (response) {
    let disposition = response.xhr.getResponseHeader('Content-Disposition');
    if (disposition) {
      const fileName = disposition.substring(21, disposition.length - 1);
      const mime = getMimeType(fileName);
      return new File([], fileName, {type: mime});
      // return new File([response.response], fileName, {type: mime});
    }
  }
};

//get mime type
const getMimeType = (fileName) => {
  if (fileName) {
    const subfix = fileName.substring(fileName.indexOf('.'));
    if (subfix === '.pdf') {
      return 'application/pdf';
    }
    if (subfix === '.txt') {
      return 'text/plain';
    }
    if (subfix === '.png') {
      return 'image/png';
    }
    if (subfix === '.doc') {
      return 'application/msword';
    }
    if (subfix === '.xls') {
      return 'application/vnd.ms-excel';
    }
    if (subfix === '.gif') {
      return 'image/gif';
    }
  }
  return null;
};

const convertGetKnowResponse = (wResponse, params) => {
  let action = params ? params.data : '';
  if (
    action === 'equities' ||
    action === 'fixedIncome' ||
    action === 'managedFunds' ||
    action === 'exchangeTradedFunds' ||
    action === 'structuredProducts'
  ) {
    const {know} = store.getState();
    let knowResultArray = know.knowResult;
    console.log('knowResultArray', knowResultArray);
    let result = wResponse.response;
    if (
      result.questions &&
      result.questions.length &&
      knowResultArray &&
      knowResultArray.resultResponse &&
      knowResultArray.resultResponse[0].questionnaireResponse &&
      knowResultArray.resultResponse[0].questionnaireResponse[0] &&
      knowResultArray.resultResponse[0].questionnaireResponse[0].questionResponse
    ) {
      let response = knowResultArray.resultResponse[0].questionnaireResponse[0].questionResponse;
      result.questions.map((item) => {
        response.map((info, index) => {
          if (info.questionNumber === item.questionNumber) {
            item.answers.map((an) => {
              if (an.answerDisplayOrderNumber === response[index].answerNumber) {
                an.isInput = true;
              }
            });
          }
        });
      });
      console.log('result===', result);
    }
    return result;
  } else {
    return wResponse.response;
  }
};

const buildSaveKnowRequest = (params) => {
  let questions = new Array();
  if (params === 'experience') {
    questions.push(commonConfig.specialParams.expQuestionObj);
  }
  if (params === 'equities') {
    questions.push(commonConfig.specialParams.knowleageNum);
  }
  commonConfig.params.response.questionResponse = questions;
  return commonConfig.params;
};

const buildUpdateKnowRequest = (params) => {
  const {session} = store.getState();
  commonConfig.updateParams.response.questionResponse = params;
  commonConfig.updateParams.response.responseId = session.responseId;
  return commonConfig.updateParams;
};

const buildUploadFileRequest = (params) => {
  console.log('params==========', params);
  return params;
};

const getKnowQuestionResult = (data) => {
  const {know} = store.getState();
  let knowResultArray = data.resultResponse;
  let result = know.knowList;
  if (
    result.questions &&
    result.questions.length > 0 &&
    knowResultArray &&
    knowResultArray[0].questionnaireResponse &&
    knowResultArray[0].questionnaireResponse.length > 0 &&
    knowResultArray[0].questionnaireResponse[0].questionResponse
  ) {
    let response = knowResultArray[0].questionnaireResponse[0].questionResponse;
    updateResponse(knowResultArray[0].questionnaireResponse[0].responseId);
    result.responseId = knowResultArray[0].questionnaireResponse[0].responseId;
    result.questions.map((item, i) => {
      response.map((info, index) => {
        if (info.questionNumber === item.questionNumber) {
          item.answersResult = response[index].answerNumber;
          // item.answers.map((an) => {
          //   if (an.answerDisplayOrderNumber === response[index].answerNumber) {
          //     an.isInput = true;
          //   }
          // });
        }
      });
    });
  }
  return result;
};

const getknowNextStep = (params) => {
  const {know} = store.getState();
  let resData = params.response;
  let nextUrl = '';
  let groupCodes = '';
  if (resData && resData.resultResponse && resData.resultResponse[0]) {
    let knowInfo = resData.resultResponse[0].questionnaireResponse;
    if (knowInfo && knowInfo[0]) {
      groupCodes = knowInfo[0].groupCodes;
      nextUrl = knowInfo[0].nextStep;
      if (
        nextUrl === 'equities' ||
        nextUrl === 'fixedIncome' ||
        nextUrl === 'managedFunds' ||
        nextUrl === 'exchangeTradedFunds' ||
        nextUrl === 'structuredProducts'
      ) {
        ObjectHelper.triggerTealiumView(nextUrl);
        history.push('/knowledge');
      } else if (nextUrl === 'thanks' && knowInfo[0].lockDays) {
        if (know.params === 'experience') {
          history.push(`/${nextUrl}`);
        } else {
          history.push(`/locked`);
        }
      } else if (nextUrl === 'failed' && knowInfo[0].lockDays) {
        if (know.params === 'structuredProducts') {
          ObjectHelper.triggerTealiumView(nextUrl);
          history.push(`/${nextUrl}`);
        } else {
          history.push(`/locked`);
        }
      } else {
        if (nextUrl === 'experience' || nextUrl === 'passed' || nextUrl === 'progress') {
          ObjectHelper.triggerTealiumView(nextUrl);
        }
        history.push(`/${nextUrl}`);
      }
    } else {
      nextUrl = 'cover';
      ObjectHelper.triggerTealiumView(nextUrl);
      history.push(`/cover`);
    }
  } else {
    nextUrl = 'cover';
    ObjectHelper.triggerTealiumView(nextUrl);
    history.push(`/cover`);
  }
  //setup a timer the loading will disapper after 3s
  setTimeout(() => {
    const {app} = store.getState();
    console.log('This will run after 3 second,app.apiInflight in converter', app.apiInflight);
    if (app.apiInflight === 1) {
      store.dispatch(endAPI());
    }
    for (let i = 1; i < app.apiInflight; i++) {
      store.dispatch(endAPI());
    }
    // if (app.apiInflight === 2) {
    //   store.dispatch(endAPI());
    //   //store.dispatch(endAPI());
    // }
  }, 3000);
  let data = {nextUrl: nextUrl, groupCodes: groupCodes};
  return data;
};

const comeBackStep = (params) => {
  if (params) {
    if (
      params === 'equities' ||
      params === 'fixedIncome' ||
      params === 'managedFunds' ||
      params === 'exchangeTradedFunds' ||
      params === 'structuredProducts'
    ) {
      history.push('/knowledge');
    } else {
      history.push(`/${params}`);
    }
  }
  return '';
};

const redirectToBack = (params) => {
  if (!ObjectHelper.isNullOrlengthZore(params)) {
    let inputs = params.filter(
      (e) => e.questionNumber === '98' && !ObjectHelper.isNullOrEmpty(e.answerInputText),
    );
    return ObjectHelper.isNullOrlengthZore(inputs) ? false : true;
  }
  return false;
};

export {
  buildGetKnowRequest,
  convertGetKnowResponse,
  buildSaveKnowRequest,
  buildUpdateKnowRequest,
  getKnowQuestionResult,
  buildUploadFileRequest,
  getknowNextStep,
  comeBackStep,
  convertGetExpResponse,
  converGetDocId,
  dataUrlTofile,
  checkResponseStatusCode,
  getDocQuestion,
  redirectToBack,
};
